import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function FeaturesSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">为什么选择91视频网站？</h2>
          <p className="text-sm text-foreground-500 mt-2">为您打造极致的高清视频观看体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: 'ri-4k-fill', title: '4K超清画质', desc: '支持从360P到4K的多种清晰度选择，自适应网络环境' },
            { icon: 'ri-speed-up-fill', title: '极速加载', desc: '全球CDN加速节点，秒开播放无等待' },
            { icon: 'ri-vip-diamond-fill', title: '完全免费', desc: '所有视频资源免费观看，无需VIP会员' },
            { icon: 'ri-device-line', title: '多端适配', desc: '完美支持手机、平板、电脑等各类设备' },
          ].map((feature) => (
            <div key={feature.title} className="text-center p-6 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}